import { render, staticRenderFns } from "./matter_package_rule_create.vue?vue&type=template&id=c2c7582a&scoped=true&"
import script from "./matter_package_rule_create.vue?vue&type=script&lang=js&"
export * from "./matter_package_rule_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c7582a",
  null
  
)

export default component.exports